import {Component, OnInit} from '@angular/core';
import {LangChangeEvent, TranslateModule, TranslateService} from '@ngx-translate/core';
import { MatIcon } from '@angular/material/icon';
import { MatCard } from '@angular/material/card';
import { NgIf, DatePipe } from '@angular/common';
import {MaintenanceService, PlannedMaintenance} from "../../../core/services/maintenance.service";
import * as moment from "moment-timezone";
import {Router} from "@angular/router";

@Component({
    selector: 'app-maintenance-banner',
    templateUrl: './maintenance-banner.component.html',
    styleUrls: ['./maintenance-banner.component.scss'],
    standalone: true,
    imports: [NgIf, MatCard, MatIcon, DatePipe, TranslateModule]
})
export class MaintenanceBannerComponent implements OnInit {
    public next_maintenance: PlannedMaintenance;
    public showBanner: boolean = false;
    public locale!: string;
    public timezone!: string;

  constructor(private maintenanceService: MaintenanceService, private translateService: TranslateService) {
    this.next_maintenance = {end_date: "", remind_from: "", start_date: "", status: ""};
  }

  ngOnInit(): void {
    this.locale = this.translateService.currentLang;
    this.timezone = moment.tz.guess();

    this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      this.locale = event.lang;
    });

    this.maintenanceService.fetchStatus().subscribe({
      next: (status) => {
        if (status.next_maintenance) {
          this.next_maintenance = status.next_maintenance;
          this.showBanner = true;
        }
      },
      error: error => {
        console.log(error);
      }
    });
  }

}
